export const FEATURE_FLAG_REGIME_TASK_MANAGEMENT = "regime-task-management"
export const FEATURE_FLAG_SCHEDULE_HISTORY = "regime-schedule-history"
export const FEATURE_FLAG_TAILORING = "regime-tailoring"
